import React from "react";
import styled from 'styled-components';
import { COLOR_ACCENT, DEVICES } from '../../const';
import logo from '../../assets/logo.png';

const Container = styled.div`
  background-color: #F6F6F8;
  @media ${DEVICES.mobile} {
    padding: 72px 0px;
  }

  @media ${DEVICES.tablet} {
    padding: 120px 0px;
  }
`;

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: flex;
    flex-direction: column;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    flex-direction: row;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
  }
`;

const Left = styled.div`
  padding: 18px 2rem;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftTitle = styled.div`
  font-weight: 700;
  line-height: 48px;

  @media ${DEVICES.mobile} {
    font-size: 2.25rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.25em;
  }
`;

const LeftDescription = styled.div`
  margin-top: 1.5rem;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const LeftHightlight = styled.div`
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 1rem;
  background-color: #fff;
  box-shadow: 1px 25px 57px -25px rgb(0 0 0 / 20%);
`;

const LeftHightlightBold = styled.div`
  font-weight: 600;
  color: ${COLOR_ACCENT};
`;

const Right = styled.div`
  padding: 0 2rem;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 48px;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
    margin-top: 0;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightImg = styled.img`
  width: 100%;
`;


export default function FeedbackBanner() {
  return (
    <Container>
      <Inner>
        <Left>
          <LeftTitle>
            '피드백'은 <br />
            필수 입니다
          </LeftTitle>
          <LeftDescription>
            선생님과 아이들 그리고 부모는 <br />
            <strong>‘긴밀한 피드백’</strong>을 통해 신뢰를 형성합니다
          </LeftDescription>
          <LeftHightlight>
            <LeftHightlightBold>긴밀한 피드백을 토대로</LeftHightlightBold>
            부모는 한층 아이를 더 이해하게 됩니다
          </LeftHightlight>
          <LeftHightlight>
            <LeftHightlightBold>올바른 피드백을 토대로</LeftHightlightBold>
            아이는 자신의 몸을 컨트롤할 수 있다는 자신감을 가지게 됩니다
          </LeftHightlight>
        </Left>
        <Right>
          <RightImg src='https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/feedback.png' />
        </Right>
      </Inner>
    </Container>
  )
}
